import React from "react";
import Box from "@mui/material/Box";
import { alpha, useTheme } from "@mui/material/styles";

import MySelect from "../../../components/ui/Inputs/Select/MySelect";

export default function MobileHeader({ modules = [], activeKey, onChange }) {
  const theme = useTheme();
  const headerPalette = theme.palette.header ?? {
    text: theme.palette.secondary.contrastText,
    selectBg: theme.palette.background.paper,
    selectIcon: theme.palette.secondary.contrastText,
  };

  return (
    <Box sx={{ color: headerPalette.text, width: "100%" }}>
      <Box
        px={1}
        py={1}
        sx={{
          borderTop: "1px solid",
          borderTopColor: alpha(headerPalette.text, 0.18),
        }}
      >
        <MySelect
          name="mobile-admin-header-select"
          label=""
          hideLabel={true}
          value={activeKey}
          onChange={onChange}
          options={modules.map((tab) => ({ value: tab.key, label: tab.title }))}
          fullWidth={false}
          formControlSx={{ width: "100%", maxWidth: "none" }}
          selectStyles={{
            bg: headerPalette.selectBg || theme.palette.background.paper,
            icon: headerPalette.selectText || theme.palette.text.primary,
            text: headerPalette.selectText || theme.palette.text.primary,
          }}
        />
      </Box>
    </Box>
  );
}
